<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <excel v-if="changpanUser == 'admin'" />
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <!-- <i class="el-icon-caret-bottom" /> -->
          <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar">
          <template v-if="device !== 'mobile'">
            <search id="header-search" class="right-menu-item" />
          </template>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div class="logo">
              <img
                :src="avatar + '?imageView2/1/w/40/h/40'"
                class="user-avatar1"
              >
              <span>{{ mskUserName }}</span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="changePwa">
            <span>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-drawer title="修改密码" :visible.sync="drawer" :modal="false">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="ruleForm.oldPassword" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="ruleForm.newPassword" />
        </el-form-item>
        <el-button
          type="primary"
          @click="confirmClk('ruleForm')"
        >确认</el-button>
        <el-button @click="drawer = false">取消</el-button>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import excel from '@/components/excel/excel'
import { post, get } from '@/utils/request'
import {
  removeToken
} from '@/utils/auth'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search,
    excel
  },
  data() {
    return {
      drawer: false,
      mskUserName: '',
      changpanUser: '', // 登录账户的角色
      changpanUserId: '',
      ruleForm: {
        oldPassword: '',
        newPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.mskUserName = window.localStorage.getItem('mskUserName')
    this.changpanUser = window.localStorage.getItem('changpanUser')
    this.changpanUserId = window.sessionStorage.getItem('changpanUserId')
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device'])
  },
  methods: {
    confirmClk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const password = this.ruleForm.newPassword
          const id = this.changpanUserId
          post('/admin/employee/update', { password, id }).then((res) => {
            if (res.data.code != 20000) {
              this.$message({
                message: res.data.message,
                type: 'error'
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'success'
              })
              removeToken()
              location.reload()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changePwa() {
      this.drawer = true
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      // margin-right: 10px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.user-avatar1 {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-right: 20px;
}
.el-dropdown-menu {
  width: 160px;
  height: 177px;
  border-radius: 12px;
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
  .logo {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}
.el-dropdown-menu__item {
  padding: 0;
}
</style>
